import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { Header } from '../../components/header/header';
import { Footer } from '../../components/footer/footer';
import { MetaService } from '../../core/services/meta.service';

@Component({
  selector: 'app-activate-account',
  standalone: true,
  imports: [CommonModule, RouterModule, Header, Footer],
  templateUrl: './activate-account.html',
  styleUrls: ['./activate-account.css']
})
export class ActivateAccountComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private authService = inject(AuthService);
  private metaService = inject(MetaService);

  isLoading = true;
  activationSuccess = false;
  activationMessage = '';
  activationEmail = '';
  errorMessage = '';

  ngOnInit(): void {
    this.metaService.resetToDefault();

    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.isLoading = false;
      this.errorMessage = 'Token de activacion no encontrado.';
      return;
    }

    this.authService.activateAccount(token).subscribe({
      next: (response) => {
        if (response.success) {
          this.activationSuccess = true;
          this.activationEmail = response.data?.email || '';
          this.activationMessage = response.data?.message || response.message || 'Cuenta activada exitosamente. Ya puedes iniciar sesion.';
        } else {
          this.errorMessage = response.message || 'No se pudo activar la cuenta.';
        }

        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        this.errorMessage = error.error?.message || 'No se pudo activar la cuenta.';
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
